<template>
    <main>
        <v-dialog  v-model="modal_open" max-width="600" max-height="98%">
            <div style="background-color:#f6f6f7">
                <subscription-partials :info="info" v-if="modal_open" />
            </div>
        </v-dialog>
    </main>
</template>
<script>
import { EventBus } from '@/helpers/eventbus/event-bus'
import Subscription from "@/components/partials/subscription.partials.vue"

export default {
    data(){
        return{
            modal_open:false,
        }
    },
    components:{
        'subscription-partials':Subscription

    },
    props:{
        modal:{type:Boolean,required:true,default:false},
        info:{type:String,required:true,default:false},
    },
    mounted(){
    },
    methods:{
        
        showModal(){
          //this.modal_open = !this.modal_open;
        },
        
        confirm:function(){
            this.$emit('confirm')
            
        },
        remove:function(){
            this.$emit('remove')
        }
    },
    watch:{
        modal_open(val) {
            if(this.modal===val)return;
            this.$emit('modal',val)
            return;
        },
        modal:function(e){
            this.modal_open=this.modal;
        }
    }

}
</script>